var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomToolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.25391V3.00128L2.25 3.00128C1.00736 3.00128 0 4.00864 0 5.25128L0 13.7481C0 14.9907 1.00736 15.9981 2.25 15.9981L17.75 15.9981C18.9926 15.9981 20 14.9907 20 13.7481V5.25128C20 4.00864 18.9926 3.00128 17.75 3.00128H15V2.25391C15 1.01127 13.9926 0.00390625 12.75 0.00390625L7.25 0.00390625C6.00736 0.00390625 5 1.01126 5 2.25391ZM7.25 1.50391L12.75 1.50391C13.1642 1.50391 13.5 1.83969 13.5 2.25391V3.00128L6.5 3.00128V2.25391C6.5 1.83969 6.83579 1.50391 7.25 1.50391ZM5 4.50391H6.5V4.50128L13.5 4.50128V4.50391H15V4.50128H17.75C18.1642 4.50128 18.5 4.83707 18.5 5.25128V7.50132H15.5V6.75132C15.5 6.33702 15.1642 6.00132 14.75 6.00132C14.3358 6.00132 14 6.33702 14 6.75132V7.50132L6 7.50132L6 6.75132C6 6.33702 5.66421 6.00132 5.25 6.00132C4.83579 6.00132 4.5 6.33702 4.5 6.75132L4.5 7.50132H1.5L1.5 5.25128C1.5 4.83707 1.83579 4.50128 2.25 4.50128H5V4.50391ZM14 9.00132V10.2513C14 10.6655 14.3358 11.0013 14.75 11.0013C15.1642 11.0013 15.5 10.6655 15.5 10.2513V9.00132H18.5V13.7481C18.5 14.1623 18.1642 14.4981 17.75 14.4981L2.25 14.4981C1.83579 14.4981 1.5 14.1623 1.5 13.7481L1.5 9.00132H4.5V10.2513C4.5 10.6655 4.83579 11.0013 5.25 11.0013C5.66421 11.0013 6 10.6655 6 10.2513V9.00132H14Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomToolbox);
export default __webpack_public_path__ + "static/media/bottom_toolbox.3f7c38fa98d993dac7668917fc19cfcd.svg";
export { ForwardRef as ReactComponent };